import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isAccountReturnExcluded, saveAccountReturnLocation } from 'modules/account/utils';
import { getKeycloakSessionState, keycloak } from 'modules/keycloak';

/** Records each page outside Account Settings, so its Back button can return to where the user was. */
export const useTrackAccountReturnLocation = () => {
  const location = useLocation();

  useEffect(() => {
    const sessionState = getKeycloakSessionState(keycloak);
    if (!sessionState || isAccountReturnExcluded(location.pathname)) return;

    saveAccountReturnLocation(sessionState, location);
  }, [location]);
};
